import PropTypes from 'prop-types';
export const searchBarPropTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  isMobileOpen: PropTypes.bool,
  handleOpenMobile: PropTypes.func,
  setIsSearching: PropTypes.func,
  isSearching: PropTypes.bool,
  classname: PropTypes.string
};